import { render, staticRenderFns } from "./openForm.vue?vue&type=template&id=68e42c38&scoped=true&"
import script from "./openForm.vue?vue&type=script&lang=js&"
export * from "./openForm.vue?vue&type=script&lang=js&"
import style0 from "./openForm.vue?vue&type=style&index=0&id=68e42c38&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e42c38",
  null
  
)

export default component.exports